import { graphql } from "relay-runtime"

export const ch_VerifyMedicationQuery = graphql`
  query chVerifyMedicationQuery($appointmentId: ID!, $patientId: ID!, $skip: Boolean!) {
    medicationVerification: ch_medicationVerification(appointmentId: $appointmentId, patientId: $patientId)
      @skip(if: $skip) {
      ... on ch_SuccessMedicationVerificationResult {
        result {
          isVerified
          patientId
          currentAppointmentId
          lastVerifiedAt
          lastVerifiedBy
          lastVerifyMedicationStatus
        }
      }
    }
  }
`
